import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, VStack } from "native-base";
import { useEffect } from "react";
import { useTranslation } from "@madmedical/i18n";
import Button from "../atoms/Button";
import FormControl from "../form/FormControl";
import ModalContent from "../molecules/ModalContent";
import SubmitButton from "../form/SubmitButton";
import FormError from "../form/FormError";
const RepresentativeModalForm = ({ mode, onSubmitPress, onClose, isSuccess, }) => {
    useEffect(() => {
        if (isSuccess) {
            onClose();
        }
    }, [isSuccess, onClose]);
    const { t } = useTranslation();
    return (_jsx(ModalContent, Object.assign({ header: mode === "invite"
            ? t("inviteNewAuthorizedPerson")
            : t("editAuthorizedPerson"), footer: _jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ variant: "outlined", onPress: onClose }, { children: t("cancel") })), _jsx(SubmitButton, { onPress: onSubmitPress, label: mode === "invite" ? t("sendInvite") : t("save") })] }) }, { children: _jsxs(VStack, Object.assign({ space: 3, testID: "modal-form" }, { children: [_jsx(Box, { children: _jsx(FormControl, { isDisabled: mode !== "invite", name: mode === "editRepresentative" ? "fullName" : "email", isRequired: true, label: mode === "editRepresentative" ? t("name") : "Email" }) }), _jsx(Box, { children: _jsx(FormControl, { name: "note", label: t("comment"), hint: t("max20characters") + ".", maxLength: 20 }) }), _jsx(FormError, {})] })) })));
};
export default RepresentativeModalForm;
